import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import LAB_CONSTANTS from './lab-constants.js';
import { unpack } from '../../utils/index.js';

/*
 * L* [0..100]
 * a [-100..100]
 * b [-100..100]
 */
var lab2rgb = function lab2rgb() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args = unpack(args, 'lab');
  var _args = args,
    _args2 = _slicedToArray(_args, 3),
    L = _args2[0],
    a = _args2[1],
    b = _args2[2];
  var _lab2xyz = lab2xyz(L, a, b),
    _lab2xyz2 = _slicedToArray(_lab2xyz, 3),
    x = _lab2xyz2[0],
    y = _lab2xyz2[1],
    z = _lab2xyz2[2];
  var _xyz2rgb = xyz2rgb(x, y, z),
    _xyz2rgb2 = _slicedToArray(_xyz2rgb, 3),
    r = _xyz2rgb2[0],
    g = _xyz2rgb2[1],
    b_ = _xyz2rgb2[2];
  return [r, g, b_, args.length > 3 ? args[3] : 1];
};
var lab2xyz = function lab2xyz(L, a, b) {
  var kE = LAB_CONSTANTS.kE,
    kK = LAB_CONSTANTS.kK,
    kKE = LAB_CONSTANTS.kKE,
    Xn = LAB_CONSTANTS.Xn,
    Yn = LAB_CONSTANTS.Yn,
    Zn = LAB_CONSTANTS.Zn;
  var fy = (L + 16.0) / 116.0;
  var fx = 0.002 * a + fy;
  var fz = fy - 0.005 * b;
  var fx3 = fx * fx * fx;
  var fz3 = fz * fz * fz;
  var xr = fx3 > kE ? fx3 : (116.0 * fx - 16.0) / kK;
  var yr = L > kKE ? Math.pow((L + 16.0) / 116.0, 3.0) : L / kK;
  var zr = fz3 > kE ? fz3 : (116.0 * fz - 16.0) / kK;
  var x = xr * Xn;
  var y = yr * Yn;
  var z = zr * Zn;
  return [x, y, z];
};
var compand = function compand(linear) {
  /* sRGB */
  var sign = Math.sign(linear);
  linear = Math.abs(linear);
  return (linear <= 0.0031308 ? linear * 12.92 : 1.055 * Math.pow(linear, 1.0 / 2.4) - 0.055) * sign;
};
var xyz2rgb = function xyz2rgb(x, y, z) {
  var MtxAdaptMa = LAB_CONSTANTS.MtxAdaptMa,
    MtxAdaptMaI = LAB_CONSTANTS.MtxAdaptMaI,
    MtxXYZ2RGB = LAB_CONSTANTS.MtxXYZ2RGB,
    RefWhiteRGB = LAB_CONSTANTS.RefWhiteRGB,
    Xn = LAB_CONSTANTS.Xn,
    Yn = LAB_CONSTANTS.Yn,
    Zn = LAB_CONSTANTS.Zn;
  var As = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
  var Bs = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
  var Cs = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
  var Ad = RefWhiteRGB.X * MtxAdaptMa.m00 + RefWhiteRGB.Y * MtxAdaptMa.m10 + RefWhiteRGB.Z * MtxAdaptMa.m20;
  var Bd = RefWhiteRGB.X * MtxAdaptMa.m01 + RefWhiteRGB.Y * MtxAdaptMa.m11 + RefWhiteRGB.Z * MtxAdaptMa.m21;
  var Cd = RefWhiteRGB.X * MtxAdaptMa.m02 + RefWhiteRGB.Y * MtxAdaptMa.m12 + RefWhiteRGB.Z * MtxAdaptMa.m22;
  var X1 = (x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20) * (Ad / As);
  var Y1 = (x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21) * (Bd / Bs);
  var Z1 = (x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22) * (Cd / Cs);
  var X2 = X1 * MtxAdaptMaI.m00 + Y1 * MtxAdaptMaI.m10 + Z1 * MtxAdaptMaI.m20;
  var Y2 = X1 * MtxAdaptMaI.m01 + Y1 * MtxAdaptMaI.m11 + Z1 * MtxAdaptMaI.m21;
  var Z2 = X1 * MtxAdaptMaI.m02 + Y1 * MtxAdaptMaI.m12 + Z1 * MtxAdaptMaI.m22;
  var r = compand(X2 * MtxXYZ2RGB.m00 + Y2 * MtxXYZ2RGB.m10 + Z2 * MtxXYZ2RGB.m20);
  var g = compand(X2 * MtxXYZ2RGB.m01 + Y2 * MtxXYZ2RGB.m11 + Z2 * MtxXYZ2RGB.m21);
  var b = compand(X2 * MtxXYZ2RGB.m02 + Y2 * MtxXYZ2RGB.m12 + Z2 * MtxXYZ2RGB.m22);
  return [r * 255, g * 255, b * 255];
};
export default lab2rgb;
export { xyz2rgb };